import Api from "../services/AxiosService";
import { unwrap } from "./envelope";

// svc-04 `/v1/pemserter-price-list-usd*` admin CRUD over the USD projection
// of haeger_pemserter_price_list. Numerics are decimal STRINGS on the wire
// (§J — never float for money). Parallels pemserterPriceListEur.ts.

export interface PemserterPriceListUsd {
  rowId: number;
  itemNumber: string | null;
  itemName: string | null;
  /** numeric(14,6) — decimal string. */
  customerSalesPriceUsd: string | null;
  /** numeric(14,6) — decimal string. */
  distributorNetPriceUsd: string | null;
  /** numeric(18,10). */
  discountRate: string | null;
  /** numeric(10,4). */
  discountPercent: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PemserterPriceListUsdPagination {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface PaginatedPemserterPriceListUsd {
  data: PemserterPriceListUsd[];
  pagination: PemserterPriceListUsdPagination;
}

export interface ListPemserterPriceListUsdParams {
  page?: number;
  limit?: number;
  search?: string;
}

export interface CreatePemserterPriceListUsdBody {
  itemNumber: string;
  itemName: string;
  customerSalesPriceUsd?: string | number | null;
  distributorNetPriceUsd?: string | number | null;
  discountRate?: string | number | null;
  discountPercent?: string | number | null;
}

export type UpdatePemserterPriceListUsdBody = Partial<CreatePemserterPriceListUsdBody>;

const BASE = "/v1/pemserter-price-list-usd";

/** GET /v1/pemserter-price-list-usd — paginated, soft-deleted excluded. */
export async function listPemserterPriceListUsd(
  params: ListPemserterPriceListUsdParams = {},
): Promise<PaginatedPemserterPriceListUsd> {
  const res = await Api.get(BASE, { params });
  return unwrap<PaginatedPemserterPriceListUsd>(res.data);
}

/** GET /v1/pemserter-price-list-usd/:id. */
export async function getPemserterPriceListUsd(
  rowId: number,
): Promise<PemserterPriceListUsd> {
  const res = await Api.get(`${BASE}/${rowId}`);
  return unwrap<PemserterPriceListUsd>(res.data);
}

/** POST /v1/pemserter-price-list-usd. */
export async function createPemserterPriceListUsd(
  body: CreatePemserterPriceListUsdBody,
): Promise<PemserterPriceListUsd> {
  const res = await Api.post(BASE, body);
  return unwrap<PemserterPriceListUsd>(res.data);
}

/** PUT /v1/pemserter-price-list-usd/:id. */
export async function updatePemserterPriceListUsd(
  rowId: number,
  body: UpdatePemserterPriceListUsdBody,
): Promise<PemserterPriceListUsd> {
  const res = await Api.put(`${BASE}/${rowId}`, body);
  return unwrap<PemserterPriceListUsd>(res.data);
}

/** DELETE /v1/pemserter-price-list-usd/:id (soft-delete). */
export async function deletePemserterPriceListUsd(rowId: number): Promise<void> {
  await Api.delete(`${BASE}/${rowId}`);
}
